/* eslint-disable */
export default {
  trackingTemplate: 'TrackingUrlTemplate',
  finalUrlSuffix: 'FinalUrlSuffix',
  customParameters: 'UrlCustomParameters',
  customParametersName: 'UrlCustomParameters/Key',
  customParametersValue: 'UrlCustomParameters/Value'
};

